import "./qrCodeLandingPage.scss";
import moment from "moment";
import pluralize from "pluralize";
import { useDispatch } from "react-redux";
import StoreDetails from "./StoreDetails";
import AllStoresCanvas from "./AllStoresCanvas";
import React, { useEffect, useState } from "react";
import Loading from "../../../../../../common/Loading";
import Phone02 from "../../../../../../assets/Phone02";
import Typography from "../../../../../../common/Typography";
import Button from "../../../../../../common/Buttons/Button";
import Slider3 from "../../../../../../common/Slider/Slider3";
import SbAccordion from "../../../../../../common/SbAccordion";
import ArrowNarrowLeft from "../../../../../../assets/ArrowNarrowLeft";
import CheckVerified03 from "../../../../../../assets/CheckVerified03";
import CalendarCheck02Filled from "../../../../../../assets/CalendarCheck02Filled";
import { getPublicLoyalty } from "../../../../../../../redux/actions/qrCodeActions";
import LoyaltyFinalCreative from "../../../../Loyalty/Edit/components/LandingPages/LoyaltyFinalCreative";
import AdvancedLoyaltyFinalCreative from "../../../../Loyalty/Edit/components/LandingPages/AdvancedLoyaltyFinalCreative";
import { isAdvancedCashback } from "../../../../Loyalty/Edit/utils";

const QrCodeRewardPage = ({ qrCodeData, resData, currencyView }) => {
  const dispatch = useDispatch();
  const [loyaltyData, setLoyaltyData] = useState({});
  const [isLoading, toggleLoading] = useState(false);
  const [isAllStores, setIsAllStores] = useState(false);

  const customerName = resData?.customer_name || "";

  const responseObj = resData || {};
  const secondPageStatus = "claimed";

  let data = {
    qrId: qrCodeData?.id,
    terms: qrCodeData?.terms || "",
    storeName: qrCodeData?.entity_id?.name || "",
    logo: qrCodeData?.landing_page_settings?.logo || "",
    title: qrCodeData?.landing_page_settings?.title || "",
    sources: qrCodeData?.landing_page_settings?.sources || [],
    text_color: qrCodeData?.landing_page_settings?.colors?.text || "#ffffff",
    theme_color: qrCodeData?.landing_page_settings?.colors?.theme || "#038C8B",
    successPageTitle:
      qrCodeData?.landing_page_settings?.success_page_title || "",

    rewardType: qrCodeData?.reward?.type || "",
    isAllStores: qrCodeData?.entity_type === "Group" || false,
    expiryDuration: qrCodeData?.reward?.expires_in?.duration,
    expiryPeriod: qrCodeData?.reward?.expires_in?.period,
    allStoresArr: qrCodeData?.reward?.redemption?.applicable_stores || [],
    isMultipleRedemptions:
      qrCodeData?.reward?.redemption?.redemption_per_customer === "multiple",
    storeWiseItemsList: qrCodeData?.reward?.items || [],
  };

  useEffect(() => {
    // fetch loyalty data and set locally
    if (qrCodeData?.entity_type === "Store") {
      toggleLoading(true);
      dispatch(getPublicLoyalty(qrCodeData?.entity_id?.id))
        .then((payload) => {
          toggleLoading(false);
          setLoyaltyData(payload);
        })
        .catch(() => toggleLoading(false));
    }
  }, [qrCodeData, dispatch]);

  const orderValue = responseObj?.order_value || 0;
  const currPoints = responseObj?.current_points || 0;
  const lifeTimeSpent = responseObj?.lifetime_spent || 0;
  const isShowRedeemCard = responseObj?.current_points > 0;
  const pointsBranding = loyaltyData?.settings?.points_branding;
  const totalRedeemableRewards = loyaltyData?.rewards?.filter(
    (reward) => reward?.is_active && reward?.points_value <= currPoints
  )?.length;

  const confirmPageData = {
    imgSrc:
      secondPageStatus === "claimed"
        ? "/assets/icons/check-circle.svg"
        : "/assets/icons/info-circle.svg",
    title:
      secondPageStatus === "claimed"
        ? data?.successPageTitle ||
          (data?.rewardType === "loyalty"
            ? `Awesome ${customerName}! You've claimed your ${
                qrCodeData?.reward?.loyalty_bonus
              } ${pluralize(
                pointsBranding?.active ? pointsBranding?.name : "points",
                qrCodeData?.reward?.loyalty_bonus
              )}`
            : `Awesome ${customerName}! You've claimed your reward`)
        : secondPageStatus === "already_claimed"
        ? "You've already claimed this reward"
        : secondPageStatus === "for_new_customer_only"
        ? "Sorry but this reward is only for new customers"
        : secondPageStatus === "inactive_qr_code"
        ? "This QR Code is no longer active"
        : "",
    subtitle:
      secondPageStatus === "claimed"
        ? "We're waiting for you..."
        : secondPageStatus === "already_claimed"
        ? "Visit your nearest store to redeem this reward"
        : secondPageStatus === "for_new_customer_only"
        ? "Don't worry, we'll have something exciting for you real soon"
        : secondPageStatus === "inactive_qr_code"
        ? "You can visit or contact the business for more details"
        : "",
  };

  const isQrCodeExpired = moment(responseObj?.expires_at).isBefore(moment());

  const isAdvCbCreative =
    loyaltyData?.type === "cashback" &&
    isAdvancedCashback(loyaltyData?.settings?.advanced_cashback?.type);

  return (
    <div
      className="qr-landing-page"
      style={{
        color: data.text_color,
        backgroundColor: data.theme_color,
      }}
    >
      <div
        className="main-header"
        style={{
          minHeight: "300px",
          color: data.text_color,
          backgroundColor: data.theme_color,
        }}
      >
        <div className="background-icons"></div>
        <CheckVerified03 height={48} width={48} color={data?.text_color} />
        <Typography
          weight="medium"
          size="display-xl"
          customClass="reward-claimed-greet"
          style={{ color: data.text_color }}
        >
          {confirmPageData.title}
        </Typography>
        {responseObj?.expires_at && (
          <div className="expiry-details">
            <Typography size="text-md" style={{ color: data.text_color }}>
              Redeem it before it expires!
            </Typography>
            <div className="expiry-date">
              <div className="deadline-logo">
                <CalendarCheck02Filled />
              </div>
              <Typography size="text-md" style={{ color: data.text_color }}>
                {isQrCodeExpired ? "Expired on" : "Expires on"}{" "}
                <b>{moment(responseObj?.expires_at).format("Do MMM'YY")}</b>{" "}
              </Typography>
            </div>
          </div>
        )}
      </div>
      <div className="user-form">
        <div className="confirmation-body">
          <StoreDetails storeNameTxtColor={"#0e1b1b"} data={data} />
          {data.isAllStores ? (
            <>
              {secondPageStatus === "for_new_customer_only" ? (
                <div className="can-still-visit">
                  <Typography size="text-sm">
                    You can still visit our other stores
                  </Typography>
                  <Button
                    isPlain={true}
                    fullWidth={true}
                    text="View all stores"
                    handleClick={() => setIsAllStores(!isAllStores)}
                    rightIcon={<ArrowNarrowLeft color="#0d9298" rotate={180} />}
                  />
                </div>
              ) : data.rewardType === "loyalty" ? (
                <div className="loyalty-current-points">
                  <p>
                    You've total <b>{responseObj?.current_points} points</b> 🎉
                  </p>
                  <p style={{ marginBottom: "4px" }}>
                    Redeem your loyalty rewards at {data?.allStoresArr?.length}{" "}
                    stores.
                  </p>
                  <div
                    className="all-store-link"
                    onClick={() => setIsAllStores(!isAllStores)}
                  >
                    View all stores and rewards{" "}
                    <img src="/assets/icons/right-dark-arrow.svg" alt="view" />
                  </div>
                </div>
              ) : (
                <div className="for-group-qr">
                  <Typography size="text-sm">
                    Redeem this reward at all stores
                  </Typography>
                  <Button
                    isPlain={true}
                    fullWidth={true}
                    text="View all stores"
                    handleClick={() => setIsAllStores(!isAllStores)}
                    rightIcon={<ArrowNarrowLeft color="#0d9298" rotate={180} />}
                  />
                </div>
              )}
            </>
          ) : data.rewardType === "loyalty" ? (
            <div className="qr-for-store-only">
              {loyaltyData?.type === "cashback" && currPoints ? (
                <div className="total-cashback-in-store">
                  <p>
                    You have{" "}
                    <span>
                      {" "}
                      {!pointsBranding?.active ? currencyView : ""}
                      {currPoints}{" "}
                      {pointsBranding?.active
                        ? pluralize(pointsBranding?.name, currPoints)
                        : "cashback"}
                    </span>
                  </p>
                </div>
              ) : (
                <>
                  {isShowRedeemCard && (
                    <>
                      {totalRedeemableRewards > 0 ? (
                        <div className="qr-redeemable-reward-div">
                          <div className="show-available-points">
                            <span>Hello {customerName},</span>
                            <span>
                              You have{" "}
                              <b>
                                {currPoints}{" "}
                                {pluralize(
                                  pointsBranding?.active
                                    ? pointsBranding?.name
                                    : "points",
                                  currPoints
                                )}
                              </b>
                            </span>
                          </div>

                          <div className="show-total-rewards">
                            <img
                              src="/assets/images/qr/others/unlock.svg"
                              alt="unlock"
                            />
                            <span>
                              {totalRedeemableRewards}{" "}
                              {pluralize("Rewards", totalRedeemableRewards)}{" "}
                              Unlocked 🎉
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="qr-non-redeemable-rewards-div">
                          <p>
                            You're{" "}
                            <b>
                              {loyaltyData?.rewards?.[0]?.points_value -
                                currPoints}{" "}
                              {pluralize(
                                pointsBranding?.active
                                  ? pointsBranding?.name
                                  : "points",
                                currPoints
                              )}
                            </b>{" "}
                            away from your first reward
                          </p>
                          {currPoints <=
                            loyaltyData?.rewards?.[0]?.points_value && (
                            <div className="slider-row">
                              <Slider3
                                min={0}
                                step={1}
                                isDisabled={true}
                                setValue={() => {}}
                                value={currPoints}
                                max={loyaltyData?.rewards?.[0]?.points_value}
                              />
                              <img
                                alt="star"
                                className="star"
                                src="/assets/images/qr/others/star.svg"
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  {isAdvCbCreative ? (
                    <AdvancedLoyaltyFinalCreative
                      isShortlink={true}
                      loyaltyData={loyaltyData}
                      storeName={qrCodeData?.entity_id?.name || ""}
                      pointsObj={{
                        order_value: orderValue,
                        lifetime_spent: lifeTimeSpent,
                      }}
                    />
                  ) : (
                    <LoyaltyFinalCreative
                      isShortlink={true}
                      loyaltyData={loyaltyData}
                      pointsObj={{ current_points: currPoints }}
                      storeName={qrCodeData?.entity_id?.name || ""}
                    />
                  )}
                  {isLoading && <Loading customClass={"component-loader"} />}
                </>
              )}
            </div>
          ) : (
            <></>
          )}
          {secondPageStatus !== "for_new_customer_only" && (
            <>
              <div className="redeem-dets">
                <div className="left">
                  <Typography
                    size="text-sm"
                    weight="medium"
                    customClass="how-to-redeem"
                  >
                    How to redeem?
                  </Typography>
                  <Typography weight="medium" size="text-sm">
                    Give your mobile number to the staff on your next purchase
                    and ask them to redeem.
                  </Typography>
                </div>
                <Phone02 color={"#D9D6FE"} size={88.88} />
              </div>
              {data?.min_bill?.is_active ||
              data?.storeWiseItemsList?.length > 1 ||
              (data?.terms?.length > 0 &&
                data?.terms?.split("\n")?.length > 0) ? (
                <div className="terms-and-conditions">
                  <Typography size="text-sm" weight="medium">
                    Terms and Conditions
                  </Typography>
                  <ul>
                    {data?.min_bill?.is_active && (
                      <li>
                        Minimum purchase of {currencyView}
                        {data?.min_bill?.value} required to redeem reward.
                      </li>
                    )}
                    {data?.terms
                      ?.split("\n")
                      .map((term, i) =>
                        term?.length > 0 ? <li key={i}>{term}</li> : <></>
                      )}
                  </ul>
                  {data?.storeWiseItemsList?.length > 1 && (
                    <div className="qr-landing-page-terms-accordion">
                      <SbAccordion title="Discount valid on specific items">
                        <Typography size="text-xs">
                          {data?.storeWiseItemsList
                            ?.map((item) => item.name)
                            ?.join(" • ")}
                        </Typography>
                      </SbAccordion>
                    </div>
                  )}
                </div>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </div>
      <AllStoresCanvas
        data={data}
        isOpen={isAllStores}
        customerName={customerName}
        toggleCanvas={() => setIsAllStores(!isAllStores)}
        pointsObj={{
          order_value: orderValue,
          current_points: currPoints,
          lifetime_spent: lifeTimeSpent,
        }}
      />
    </div>
  );
};

export default QrCodeRewardPage;
